/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form ? this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]') : [];
      this.countrySwitchers = this.querySelectorAll('[data-country-switcher]');
      const debounceFunction = typeof debounce === 'function' ? debounce : ((callback) => callback);
      this.debouncedOnSubmit = debounceFunction((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
      this.setupCountrySwitchers();
    }

    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }

    setupCountrySwitchers() {
      this.countrySwitchers.forEach((switcher) => {
        if (switcher.dataset.countrySwitcherReady === 'true') {
          return;
        }

        switcher.dataset.countrySwitcherReady = 'true';

        const countryInput = switcher.querySelector('[data-country-input]');
        const searchInput = switcher.querySelector('[data-country-search]');
        const options = Array.from(switcher.querySelectorAll('[data-country-option]'));
        const flags = switcher.querySelectorAll('.chalk-country-switcher__flag[data-country-code]');

        flags.forEach((flag) => {
          flag.textContent = this.flagFromCountryCode(flag.dataset.countryCode || flag.textContent);
        });

        options.forEach((option) => {
          option.addEventListener('click', () => {
            if (!this.form || !countryInput) {
              return;
            }

            countryInput.value = option.dataset.countryCode;
            this.form.submit();
          });
        });

	        if (searchInput) {
	          const searchWrap = searchInput.closest('.chalk-country-switcher__search-wrap');

	          searchInput.addEventListener('input', () => {
	            const query = searchInput.value.trim().toLowerCase();

	            if (searchWrap) {
	              searchWrap.classList.toggle('has-query', query.length > 0);
	            }
	
	            options.forEach((option) => {
	            const searchableText = [
	                option.dataset.countryName || '',
	                option.dataset.countryCode || '',
	                option.dataset.countryCurrency || ''
	              ].join(' ').toLowerCase();

              option.hidden = query.length > 0 && !searchableText.includes(query);
            });
          });

	          switcher.addEventListener('toggle', () => {
	            if (!switcher.open) {
	              searchInput.value = '';
	              if (searchWrap) {
	                searchWrap.classList.remove('has-query');
	              }
	              options.forEach((option) => {
	                option.hidden = false;
	              });
            }
          });
        }

        switcher.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            switcher.open = false;
          }
        });

        document.addEventListener('click', (event) => {
          if (!switcher.contains(event.target)) {
            switcher.open = false;
          }
        });
      });
    }

	    flagFromCountryCode(countryCode) {
	      const code = (countryCode || '').trim().toUpperCase();

      if (!/^[A-Z]{2}$/.test(code)) {
        return code;
      }

      return Array.from(code)
        .map((character) => 127397 + character.charCodeAt(0))
        .map((codePoint) => String.fromCodePoint(codePoint))
        .join('');
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
